"use client";

import { useMemo } from "react";
import type {
  BrowseMode,
  ListingSummary,
} from "@/lib/browse/getHomeBrowseData";
import { selectEditorialCategoryListings } from "@/lib/homepage/editorial";
import EditorialCategoryBand from "./EditorialCategoryBand";
import MerchantFeatureBand from "./MerchantFeatureBand";

const BAND_TONES = ["cream", "rose", "ivory"] as const;

export default function HomepageEditorialSections({
  listings,
  mode,
}: {
  listings: ListingSummary[];
  mode: BrowseMode;
}) {
  const categories = useMemo(
    () => selectEditorialCategoryListings(listings),
    [listings]
  );

  return (
    <div data-testid="homepage-editorial-sections">
      {categories.map((category, index) => (
        <EditorialCategoryBand
          key={category.id}
          category={category}
          mode={mode}
          tone={BAND_TONES[index]}
        />
      ))}
      <MerchantFeatureBand mode={mode} />
    </div>
  );
}
